import React from "react";
import CommonStepper from "../components/common/CommonStepper";

const CreateProfileLayout = ({ children }) => {
  return (
    <div className="container-fluid bg-common common-about-fluid">
      <div className="container">
        <div className="row common-wrapper-row">
          <div className="col-12">
            <CommonStepper />
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateProfileLayout;
